module.exports = __webpack_public_path__ + "img/result-title.4ee87f77.png";